import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { ArrowUpIcon } from "lucide-react";
import { useState } from "react";
import {
  Button,
  DateInput,
  FileInput,
  NumberInput,
  SelectInput,
  SubmitButton,
  SwitchInput,
  TextareaInput,
} from "~/design-system/components";
import { Option } from "~/design-system/types";
import {
  requestCustomCakesDataAtom,
  requestCustomCakesStepsAtom,
} from "../../atoms";
import { useRequestOrder } from "../../hooks";
import { requestCustomCakesPortal } from "../RequestCutomCakesPortal";

export function RequestCustomCakeInformation() {
  const { handleSubmitOrderRequest, orderOptions, formData } = useRequestOrder({
    portal: requestCustomCakesPortal,
    type: "customized",
    dataAtom: requestCustomCakesDataAtom,
    stepsAtom: requestCustomCakesStepsAtom,
  });

  const currentDate = new Date();

  const [dateInputName, setDateInputName] = useState<
    "eventDate" | "pickupDate"
  >("eventDate");

  return (
    <Form
      onSubmit={handleSubmitOrderRequest}
      className="grid grid-cols-2 items-start gap-4 lg:gap-8"
    >
      <div className="col-span-2 flex items-start">
        <SwitchInput
          name="pickup"
          label={trans("pickup")}
          classes={{
            wrapper: "flex-row w-full rounded-full border px-6 py-4",
          }}
          onChange={(value) => {
            setDateInputName(value ? "pickupDate" : "eventDate");
          }}
        />
      </div>
      <NumberInput
        name="numberOfServings"
        placeholder={trans("numberOfServings")}
        label={trans("numberOfServings")}
        defaultValue={formData?.numberOfServings}
        required
        autofocus
        classes={{
          wrapper: "max-lg:col-span-2",
        }}
      />
      <SelectInput
        name="filling"
        placeholder={trans("flavor")}
        label={trans("flavor")}
        defaultValue={formData?.filling}
        required
        options={(orderOptions?.fillings as Option[]) || []}
        classes={{
          wrapper: "max-lg:col-span-2",
        }}
      />
      <SelectInput
        name="size"
        placeholder={trans("numberOfTiers")}
        label={trans("numberOfTiers")}
        defaultValue={formData?.size}
        required
        options={(orderOptions?.sizes as Option[]) || []}
        classes={{
          wrapper: "max-lg:col-span-2",
        }}
      />
      <FileInput
        name="images"
        label={trans("uploadThreePhotos")}
        required
        multiple
        maxFiles={3}
        classes={{
          wrapper: "max-lg:col-span-2",
        }}
      />
      {dateInputName === "eventDate" && (
        <DateInput
          name="deliveryDate"
          label={trans("deliveryDate")}
          required
          minDate={currentDate}
          classes={{
            wrapper: "max-lg:col-span-2",
          }}
        />
      )}
      {dateInputName === "pickupDate" && (
        <DateInput
          name="pickupDate"
          label={trans("pickupDate")}
          required
          minDate={currentDate}
          classes={{
            wrapper: "max-lg:col-span-2",
          }}
        />
      )}
      <div className="flex h-full w-full items-end max-lg:col-span-2">
        <SwitchInput
          name="setupOption"
          label={trans("setupOption")}
          classes={{
            wrapper: "flex-row w-full rounded-full border px-6 py-4",
          }}
        />
      </div>
      <TextareaInput
        name="message"
        placeholder={trans("message")}
        label={trans("typeCakeMessage")}
        classes={{
          wrapper: "col-span-2",
        }}
        rows={6}
        required
      />
      <div className="col-span-2 flex flex-col items-center gap-4 lg:flex-row">
        <Button
          onClick={() => requestCustomCakesStepsAtom.update(1)}
          className="border-night col-span-2 w-full items-center justify-center rounded-full border bg-gray-200 px-8 py-3 text-center text-base font-semibold transition-colors duration-200 hover:bg-gray-300 sm:text-lg"
        >
          {trans("back")}
        </Button>
        <SubmitButton className="bg-primary-200 hover:bg-primary-300 border-night col-span-2 w-full items-center justify-center rounded-full border px-8 py-3 text-center text-base font-semibold transition-colors duration-200 sm:text-lg">
          {trans("sendRequest")} <ArrowUpIcon className="h-5 w-5 rotate-45" />
        </SubmitButton>
      </div>
    </Form>
  );
}
